module.exports = __webpack_public_path__ + "img/porsche911bg.60560761.png";